import { Spinner } from '@heroui/react'
import { useTranslations } from 'use-intl'
import { PublicLayout } from '~/components/layout/public-layout'
import { IntlProvider } from '../providers/intl-provider'

function DefaultPendingBase() {
  const t = useTranslations('components.loading')
  return (
    <PublicLayout>
      <div role="status" aria-live="polite" className="mx-auto flex min-h-[50vh] w-full max-w-3xl flex-col items-center justify-center gap-4 p-8 text-center">
        <Spinner size="lg" />
        <h1 className="mt-4 text-2xl font-black text-foreground">{t('title')}</h1>
        <p className="max-w-md text-muted">{t('body')}</p>
      </div>
    </PublicLayout>
  )
}

export function DefaultPending() {
  return (
    <IntlProvider>
      <DefaultPendingBase />
    </IntlProvider>
  )
}
